import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { useTranslation } from "react-i18next";

import DialogBackdrop from "../DialogBackdrop";

export default function UploadDocumentsConfirmationModal({
  confirmationModalState,
  setConfirmationModalState,
}) {
  const { t } = useTranslation();

  return (
    <Transition appear show={confirmationModalState} as={Fragment}>
      <Dialog
        className="fixed inset-0 z-10 overflow-y-auto"
        as="div"
        open={confirmationModalState}
        onClose={() => null}
      >
        <DialogBackdrop />

        <div className="min-h-screen px-4 text-center">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0" />
          </Transition.Child>
          {/* This element is to trick the browser into centering the modal contents. */}

          <span
            className="inline-block h-screen align-middle"
            aria-hidden="true"
          >
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <div className="inline-block w-full max-w-2xl p-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl">
              <Dialog.Title
                as="h2"
                className="dialog_label2 font-body text-xl font-bold text-left"
              >
                {t("UploadDocumentsConfirmationModal-title")}
                <button
                  className="ui-default-dialog-close"
                  onClick={() => {
                    setConfirmationModalState(false);
                  }}
                >
                  <svg
                    className="ui-icon h-3.5 w-3.5"
                    focusable="false"
                    aria-hidden="true"
                    role="presentation"
                  >
                    <use href="#ui-icon-close"></use>
                  </svg>
                </button>
              </Dialog.Title>

              <hr />
              <div className="font-semibold text-xl text-center">
                <div className="pb-3 justify-items-center">
                  <svg width="81" height="80" viewBox="0 0 81 80" fill="none">
                    <path
                      d="M30.5 42.5L38 50L50.5 32.5M70.5 40C70.5 56.5685 57.0685 70 40.5 70C23.9315 70 10.5 56.5685 10.5 40C10.5 23.4315 23.9315 10 40.5 10C57.0685 10 70.5 23.4315 70.5 40Z"
                      stroke="#288049"
                      stroke-width="5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <div className="pb-4">Thank You!</div>
                <p>{t("UploadDocumentsConfirmationModal-p1")}</p>
                <p>{t("UploadDocumentsConfirmationModal-p2")}</p>
                <p>{t("UploadDocumentsConfirmationModal-p3")}</p>
              </div>
              <div className="flex justify-end my-4">
                <button
                  className="ui-btn-primary ui-btn-min-w ml-2"
                  onClick={() => {
                    setConfirmationModalState(false);
                  }}
                >
                  {t("UploadDocumentsConfirmationModal-close")}
                </button>
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
}
